// extracted by mini-css-extract-plugin
module.exports = {"iconSecondary":"index-module--iconSecondary--1tn3A","iconResearchSecondary":"index-module--iconResearchSecondary--2djmh"};